// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-main__header{
    font-size: 4rem;
    font-weight: 600;
    text-align: center;
}

.mailing-main {
    width: 100%;
    height: 100%;
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/MailingMain.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".mailing-main__header{\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.mailing-main {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
